import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
    name: 'ui',
    initialState: { modalIsVisible: false, notification: null, isRequestSending: false, isRedirectServerErrorPage: false, isPageLoaded: true },
    reducers: {
        toggle(state) {
            state.modalIsVisible = !state.modalIsVisible;
        },
        showNotification(state, action) {
            state.notification = {
                status: action.payload.status,
                title: action.payload.title,
                message: action.payload.message,
            };
            state.modalIsVisible = action.payload.isVisible;
            state.isRedirectServerErrorPage = action.payload.isRedirectServerErrorPage;
        },
        setRequestStatus(state, action) {
            state.isRequestSending = action.payload.isRequestSending;
        },
        setLocalizationRequestStatus(state, action) {
            state.isLocalizationRequestRunning = action.payload.isLocalizationRequestRunning;
        },
        setPageLoadingStatus(state, action) {
            state.isPageLoaded = action.payload.isPageLoaded;
        }
    },
});

export const uiActions = uiSlice.actions;

export default uiSlice;
